import { AppButton, AppDivider, AppGroup, AppSegment } from 'client/ui-building-blocks'

const GroupPreview = () => {
  return (
    <>
      <AppSegment headerProps={{ text: 'Horizontal', marginBottom: 'small' }}>
        <AppGroup>
          <AppButton text="Button 1" />
          <AppButton text="Button 2" />
          <AppButton text="Button 3" />
        </AppGroup>
      </AppSegment>
      <AppSegment headerProps={{ text: 'Vertical', marginBottom: 'small' }}>
        <AppGroup alignment="vertical">
          <AppButton variant="info" text="Button 1" />
          <AppButton variant="info" text="Button 2" />
          <AppButton variant="info" text="Button 3" />
        </AppGroup>
      </AppSegment>
      <AppSegment
        headerProps={{ text: 'Horizontal and centered', marginBottom: 'small' }}
      >
        <AppGroup position="center">
          <AppButton variant="warning" text="Button 1" />
          <AppButton variant="warning" text="Button 2" />
          <AppButton variant="warning" text="Button 3" />
        </AppGroup>
        <AppDivider />
      </AppSegment>
      <AppSegment headerProps={{ text: 'Vertical and centered', marginBottom: 'small' }}>
        <AppGroup alignment="vertical" position="center">
          <AppButton variant="error" text="Button 1" />
          <AppButton variant="error" text="Button 2" />
          <AppButton variant="error" text="Button 3" />
        </AppGroup>
        <AppDivider />
      </AppSegment>
      <AppSegment
        headerProps={{ text: 'Horizontal and right aligned', marginBottom: 'small' }}
      >
        <AppGroup position="right">
          <AppButton variant="outlined" text="Button 1" />
          <AppButton variant="outlined" text="Button 2" />
          <AppButton variant="outlined" text="Button 3" />
        </AppGroup>
        <AppDivider />
      </AppSegment>
      <AppSegment
        headerProps={{ text: 'Vertical and right aligned', marginBottom: 'small' }}
      >
        <AppGroup alignment="vertical" position="right">
          <AppButton variant="dark" text="Button 1" />
          <AppButton variant="dark" text="Button 2" />
          <AppButton variant="dark" text="Button 3" />
        </AppGroup>
        <AppDivider />
      </AppSegment>
      <AppSegment
        headerProps={{ text: 'Horizontal and full width', marginBottom: 'small' }}
      >
        <AppGroup fullWidth>
          <AppButton text="Button 1" />
          <AppButton text="Button 2" />
          <AppButton text="Button 3" />
        </AppGroup>
      </AppSegment>
      <AppSegment
        headerProps={{ text: 'Vertical and full width', marginBottom: 'small' }}
      >
        <AppGroup alignment="vertical" fullWidth>
          <AppButton variant="info" text="Button 1" />
          <AppButton variant="info" text="Button 2" />
          <AppButton variant="info" text="Button 3" />
        </AppGroup>
      </AppSegment>
    </>
  )
}

export default GroupPreview
